import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";
import { useHistory, useLocation } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { useMst } from "@store/Route";
import Swal from "sweetalert2";
import { formatPrice } from "@utils/format";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import tz from "dayjs/plugin/timezone";
import CircularProgress from "@mui/material/CircularProgress";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

import "./Payments.scss";
import OnProcessCard from "./components/OnProcessCard";
import OutstandingCard from "./components/OutstandingCard";
import HistoryCard from "./components/HistoryCard";
import InfiniteScroll from "react-infinite-scroller";
import RefreshIcon from "@mui/icons-material/Refresh";
import { delay } from "@utils/helper";
import usePayment from "./components/usePayment";
import { useWidth } from "@utils/demenstion";
import PaymentGatway from "./components/PaymentGatway";
import OutstandingPlaceholder from "./placeholder/OutstandingPlaceholder";
import ProcessingPlaceholder from "./placeholder/ProcessingPlaceholder";
import HistoryPlaceholder from "./placeholder/HistoryPlaceholder";
import { AlertError } from "@utils/alert";
import { OutstandingDataType, SelectedItemType } from "@store/Outstanding";

dayjs.extend(utc);
dayjs.extend(tz);

const DashboardPayments = observer(() => {
  const widthScreen = useWidth();
  let history = useHistory();

  const {
    payment,
    landing,
    onProcess,
    outstandingPayment,
    historyPayment,
    globalTime,
    customers,
    profile,
  } = useMst();
  const { token } = landing;
  const {
    createNewPayment,
    fetchingCreatePayment,
    resetNewPayment,
    setActiveInvoiceTabSection,
    activeInvoiceTabSection,
  } = payment;

  const {
    outstandingDatas,
    getOutstanding,
    setTotalBill,
    fetchingOutstanding,
    initialStateOutstanding,
    setSelectItemsInvoice,
    selectedItemsInvoice,
  } = outstandingPayment;

  const {
    historyPaymentData,
    getHistoryPayment,
    fetchingHistoryPayment,
    initialStateHistoryPayment,
  } = historyPayment;

  const {
    getOnProcess,
    fetchingOnProcess,
    onProcessPayment,
    fetchingOnProcessMore,
    paginationOnProcess,
    deleteOnProcess,
    fetchingDeleteOnProcess,
  } = onProcess;

  const { getTimeGlobal, time } = globalTime;

  const { profileUser } = profile;

  /**
   * It gets all the data from the server.
   * @param {number} timeDelay - number
   */
  const getAllData = async (timeDelay: number) => {
    if (token && profileUser?.user?.accountingCustomerId) {
      console.log("ds");
      setActiveInvoiceTabSection("1");
      await delay(timeDelay);
      await getOnProcess(token);
      resetNewPayment();
      getOutstanding(token);
      getTimeGlobal();
      getTotalOutstandingPrice();
      await delay(2000);
    }
  };

  const getTotalOutstandingPrice = useCallback(() => {
    if (token && profileUser?.user?.accountingCustomerId) {
      customers.getOutstandingPrice(
        token,
        profileUser.user.accountingCustomerId
      );
    }
  }, [token, profileUser?.user?.accountingCustomerId]);

  const {
    handleInvoiceItemClick,
    handePayment,
    calculationTotal,
    messageError,
  } = usePayment({ getAllData, setSelectItemsInvoice, selectedItemsInvoice });

  console.log(selectedItemsInvoice);

  useLayoutEffect(() => {
    initialStateOutstanding();
    initialStateHistoryPayment();
    if (token) {
      // getOnProcess(token);
    }
  }, []);

  useEffect(() => {
    if (token) {
      switch (activeInvoiceTabSection) {
        case "0":
          initialStateHistoryPayment();
          resetNewPayment();
          getOutstanding(token);
          break;
        case "1":
          getOnProcess(token);
          break;
        case "2":
          getHistoryPayment(token);
          break;
        default:
          break;
      }
      getTotalOutstandingPrice();
      getTimeGlobal();
    }
  }, [activeInvoiceTabSection]);

  /* A callback function that is being called when the user clicks on the pay button. */
  const onPay = useCallback(
    (type: string) => {
      handePayment(() => {
        if (
          calculationTotal(selectedItemsInvoice) === 0 &&
          selectedItemsInvoice &&
          selectedItemsInvoice.length !== 0 &&
          token
        ) {
          createNewPayment(
            token,
            selectedItemsInvoice,
            "stripe",
            "",
            async (callback) => {
              resetNewPayment();
              if (callback.url === null || callback.url === undefined) {
                setActiveInvoiceTabSection("0");
                return;
              }
              window.location.href = callback.url;
              await delay(500);
              setActiveInvoiceTabSection("1");
            }
          );
        } else if (
          selectedItemsInvoice.length !== 0 &&
          token &&
          type === "stripe"
        ) {
          history.push("/dashboard/payment/stripe");
          setTotalBill(calculationTotal(selectedItemsInvoice));
        }
      });
    },
    [selectedItemsInvoice, token]
  );

  const titlePayment = () => {
    if (activeInvoiceTabSection === "0") {
      return "Outstanding Payment";
    }
    if (activeInvoiceTabSection === "1") {
      return "Processing Payment";
    }
    if (activeInvoiceTabSection === "2") {
      return "History Payment";
    }
  };

  const getMoreDataOnProcess = useCallback(() => {
    if (
      token &&
      paginationOnProcess?.hasNext &&
      fetchingOnProcessMore !== "pending"
    ) {
      getOnProcess(token, paginationOnProcess.currentPage + 1);
    }
  }, [token, fetchingOnProcessMore, paginationOnProcess]);

  const deleteOnProcessAction = useCallback(
    (paymentId: number) => {
      if (token) {
        deleteOnProcess(token, paymentId, () => {
          getAllData(0);
        });
      }
    },
    [token]
  );

  const loader = (
    <div className="loader">
      Loading{" "}
      <CircularProgress
        style={{ color: "white", marginLeft: 10 }}
        size={20}
      ></CircularProgress>
    </div>
  );

  return (
    <>
      <div className="DashboardPayments relative">
        <div className="relative">
          {/* Layout List */}
          <div
            className={`${
              activeInvoiceTabSection === "0" ? "w-full" : " md:w-8/12 w-full"
            }`}
          >
            <p className="mb-5  header--30 color--white">{titlePayment()}</p>
            {/* Outstanding Price */}
            <p className="mb-5 header--24 color--white">
              {`Outstanding: ${
                customers.fetching === "pending"
                  ? ""
                  : formatPrice(customers.data?.balance || 0)
              }`}
              {customers.fetching === "pending" ? (
                <CircularProgress
                  style={{ color: "white", marginLeft: 10 }}
                  size={20}
                ></CircularProgress>
              ) : null}
            </p>

            <div>
              {/* Tab Payment */}
              <div
                className={`flex overflow-x-autoscrollbarHide space-x-14 !pt-5 border-solid border-b border-blue-600 mb-4
                ${
                  activeInvoiceTabSection === "0" ? "md:w-2/3 w-full" : "w-full"
                }`}
              >
                <p
                  className={`header--18 DashboardPayments__btn border-solid pb-4	 ${
                    activeInvoiceTabSection == "0" ||
                    activeInvoiceTabSection == "onMountInitState"
                      ? "active border-b-4 border-bahama_blue_hover"
                      : ""
                  }`}
                  onClick={() => {
                    // Prevent state change if its still in onMountInitState,
                    // to prevent first section from being triggered again
                    if (activeInvoiceTabSection != "onMountInitState") {
                      setActiveInvoiceTabSection("0");
                    }
                  }}
                >
                  Outstanding
                  {outstandingDatas && outstandingDatas.length !== 0 ? (
                    <FiberManualRecordIcon className="absolute text-red-500"></FiberManualRecordIcon>
                  ) : (
                    ""
                  )}
                </p>
                <p
                  className={`header--18 DashboardPayments__btn border-solid pb-4 ${
                    activeInvoiceTabSection == "1"
                      ? "active  border-b-4 border-bahama_blue_hover"
                      : ""
                  }`}
                  onClick={() => {
                    setActiveInvoiceTabSection("1");
                  }}
                >
                  Processing
                  {onProcessPayment && onProcessPayment.length !== 0 ? (
                    <FiberManualRecordIcon className="dot"></FiberManualRecordIcon>
                  ) : (
                    ""
                  )}
                </p>
                <p
                  className={`header--18 DashboardPayments__btn border-solid pb-4 ${
                    activeInvoiceTabSection == "2"
                      ? "active  border-b-4 border-bahama_blue_hover"
                      : ""
                  }`}
                  onClick={() => {
                    setActiveInvoiceTabSection("2");
                  }}
                >
                  History
                </p>
              </div>

              {/* List Card Payment */}

              {/* Outstanding */}
              <div>
                {fetchingOutstanding === "pending" &&
                activeInvoiceTabSection == "0" ? (
                  <div className="DashboardInvoiceHolder__anim--onBoard">
                    <OutstandingPlaceholder />
                  </div>
                ) : (
                  <div
                    key={0}
                    className={`DashboardInvoiceHolder ${
                      activeInvoiceTabSection == "0"
                        ? "DashboardInvoiceHolder__anim--onBoard"
                        : activeInvoiceTabSection == "onMountInitState"
                        ? ""
                        : "d-none"
                    }`}
                  >
                    <div
                      className="row col-12 no-gutters"
                      onClick={async () => {
                        if (token) {
                          getTotalOutstandingPrice();
                          getTimeGlobal();
                          getOutstanding(token);
                        }
                      }}
                    >
                      <span className="refresh">
                        Refresh <RefreshIcon fontSize="large"></RefreshIcon>
                      </span>
                    </div>
                    {outstandingDatas && outstandingDatas.length !== 0 ? (
                      <div className="flex md:flex-row md:space-x-4 flex-col relative">
                        <div className="md:w-8/12 w-full">
                          <InfiniteScroll
                            pageStart={0}
                            loadMore={() => {
                              // getMoreDataOutstanding();
                            }}
                            // hasMore={outstandingDatas.nextLink ? true : false}
                            loader={loader}
                          >
                            {outstandingDatas.map(
                              (item: OutstandingDataType) => {
                                const findItem = selectedItemsInvoice.find(
                                  (selectedItem: SelectedItemType) =>
                                    selectedItem.accountingDocumentId ===
                                    item.accountingDocumentId
                                );
                                return (
                                  <OutstandingCard
                                    key={item.accountingDocumentId}
                                    onChange={() => {
                                      item.accountingDocumentId
                                        ? handleInvoiceItemClick({
                                            accountingDocumentId:
                                              item.accountingDocumentId,
                                            accountingDocumentNumber:
                                              item.accountingDocumentNumber,
                                            error: null,
                                            originalAmount: item.originalAmount,
                                            reductionId: null,
                                            remainingAmount:
                                              item.remainingAmount,
                                            type: item.type,
                                          })
                                        : null;
                                    }}
                                    checked={findItem ? true : false}
                                    token={token || ""}
                                    {...item}
                                    error={findItem?.error ? true : false}
                                  />
                                );
                              }
                            )}
                          </InfiniteScroll>
                        </div>

                        {/* Button Payment  */}
                        {widthScreen > 968 &&
                        activeInvoiceTabSection === "0" ? (
                          <PaymentGatway
                            calculationTotal={calculationTotal(
                              selectedItemsInvoice
                            )}
                            fetchingCreatePayment={fetchingCreatePayment}
                            onPay={onPay}
                            selectedItems={selectedItemsInvoice}
                            activeInvoiceTabSection={activeInvoiceTabSection}
                            messageError={messageError}
                          />
                        ) : null}
                      </div>
                    ) : (
                      <div className="w-100 paymentsNoOutstanding__mainWrapper">
                        <div className="paymentsNoOutstanding__ico" />
                        <div className="row no-gutters">
                          <p className="offset-3 col-6 text-center header--16 color--blue">
                            You have no outstanding payment!
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                )}
                {/* OnProcess */}
                {fetchingOnProcess === "pending" &&
                activeInvoiceTabSection == "1" ? (
                  <div className="DashboardInvoiceHolder__anim--onBoard">
                    <ProcessingPlaceholder />
                  </div>
                ) : (
                  <section
                    key={1}
                    className={`DashboardInvoiceHolder ${
                      activeInvoiceTabSection == "1"
                        ? "DashboardInvoiceHolder__anim--onBoard"
                        : activeInvoiceTabSection == "onMountInitState"
                        ? ""
                        : "d-none"
                    }`}
                  >
                    <div
                      className="row col-12 no-gutters"
                      onClick={async () => {
                        if (token) {
                          getOnProcess(token);
                          getTotalOutstandingPrice();
                          getTimeGlobal();
                        }
                      }}
                    >
                      <span className="refresh">
                        Refresh <RefreshIcon fontSize="large"></RefreshIcon>
                      </span>
                    </div>
                    {onProcessPayment && onProcessPayment.length !== 0 ? (
                      <InfiniteScroll
                        pageStart={0}
                        loadMore={() => {
                          getMoreDataOnProcess();
                        }}
                        hasMore={paginationOnProcess?.hasNext}
                        loader={loader}
                      >
                        {onProcessPayment.map((item, index) => (
                          <OnProcessCard
                            key={`${item.id}-${index}`}
                            {...item}
                            openPdf={() => {}}
                            cancelProcess={() => {
                              item.id && deleteOnProcessAction(item.id);
                            }}
                            fetchingDeleteOnProcess={fetchingDeleteOnProcess}
                            time={time || 0}
                            onPressPayment={() => {
                              if (item.paymentPlatform === "stripe" && token) {
                                getOnProcess(token);
                                return;
                              }
                              if (item.url) {
                                window.location.href = item.url;
                              } else {
                                AlertError(
                                  "Payment no Found",
                                  "No payment link found"
                                );
                              }
                            }}
                          />
                        ))}
                      </InfiniteScroll>
                    ) : (
                      <div className="w-100 paymentsNoOutstanding__mainWrapper">
                        <div className="paymentsNoOutstanding__ico" />
                        <div className="row no-gutters">
                          <p className="offset-3 col-6 text-center header--16 color--blue">
                            You have no outstanding payment!
                          </p>
                        </div>
                      </div>
                    )}
                  </section>
                )}

                {/* History */}
                {fetchingHistoryPayment === "pending" &&
                activeInvoiceTabSection == "2" ? (
                  <div className="DashboardInvoiceHolder__anim--onBoard">
                    <HistoryPlaceholder />
                  </div>
                ) : (
                  <section
                    key={2}
                    className={`w-100 DashboardInvoiceHolder ${
                      activeInvoiceTabSection == "2"
                        ? "DashboardInvoiceHolder__anim--onBoard"
                        : activeInvoiceTabSection == "onMountInitState"
                        ? "d-none"
                        : "d-none"
                    }`}
                  >
                    {historyPaymentData && historyPaymentData.length !== 0 ? (
                      <InfiniteScroll
                        pageStart={0}
                        loadMore={() => {
                          // getMoreDataHistory();
                        }}
                        // hasMore={historyPaymentData.nextLink ? true : false}
                        loader={loader}
                      >
                        {historyPaymentData.map((item) => {
                          return (
                            <HistoryCard
                              key={item.accountingDocumentId}
                              token={token || ""}
                              {...item}
                            ></HistoryCard>
                          );
                        })}
                      </InfiniteScroll>
                    ) : (
                      <div className="w-100 paymentsNoOutstanding__mainWrapper">
                        <div className="paymentsNoOutstanding__ico" />
                        <div className="row no-gutters">
                          <p className="offset-3 col-6 text-center header--16 color--blue">
                            You have no outstanding payment!
                          </p>
                        </div>
                      </div>
                    )}
                  </section>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Button Pay Mobile */}
      {widthScreen < 968 && activeInvoiceTabSection === "0" ? (
        <PaymentGatway
          calculationTotal={calculationTotal(selectedItemsInvoice)}
          fetchingCreatePayment={fetchingCreatePayment}
          onPay={onPay}
          selectedItems={selectedItemsInvoice}
          activeInvoiceTabSection={activeInvoiceTabSection}
          messageError={messageError}
        />
      ) : null}
    </>
  );
});

export default DashboardPayments;
